const openSearch = document.querySelector('.js-open-search');
const header = document.querySelector('.header');
const searchBar = openSearch.previousElementSibling;

openSearch.addEventListener('click', function () {
  searchBar.classList.toggle('hidden');
  if (!searchBar.classList.contains('hidden')) {
    searchBar.querySelector('input[type="search"]').select();
  }
});

// fabric-guide tabs START

document.querySelectorAll('#fabric__tabs [tab-index]').forEach(function(item) {
  item.addEventListener('click', function() {
    let link = this.getAttribute('tab-index');

    // Handle fabric__content section
    let activeContent = document.querySelector('#fabric__content .active');
    if (activeContent) {
      activeContent.classList.replace("active", "hidden");
    }
    let newContent = document.querySelector('#fabric__content [tab-id="' + link + '"]');
    if (newContent) {
      newContent.classList.replace("hidden", "active");
    }

    // Handle fabric__products section
    let activeProduct = document.querySelector('#fabric__products .active');
    if (activeProduct) {
      activeProduct.classList.replace("active", "hidden");
    }
    let newProduct = document.querySelector('#fabric__products [tab-id="' + link + '"]');
    if (newProduct) {
      newProduct.classList.replace("hidden", "active");
    }

    // Update active tab
    let activeTab = document.querySelector('#fabric__tabs .active');
    if (activeTab) {
      activeTab.classList.remove("active", "bg-[#000000]", "text-white", "border-black", "font-bold");
      activeTab.classList.add("bg-white", "text-black", "border-black-100", "font-normal");
    }
    this.classList.add("active", "bg-[#000000]", "text-white", "border-black", "font-bold");
    this.classList.remove("bg-white", "text-black", "border-black-100", "font-normal");
  });
});

// Set the first tab as active by default
document.addEventListener('DOMContentLoaded', function() {
  let firstTab = document.querySelector('#fabric__tabs [tab-index="tab-1"]');
  if (firstTab) {
    firstTab.click();
  }
});

// fabric-guide tabs END